// Generated with util/create-component.js
import NavigationBar from './NavigationBar';

export default NavigationBar;
